export const enterKeyPress =
    (callback: () => void) => (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            callback()
        }
    }
